module.exports = __webpack_public_path__ + "img/hover-cod.34f86175.png";